import React from "react";

interface TermRendererProp
{
    value: any;
}

class TermRendererLine extends React.Component<TermRendererProp>
{
    render(): React.ReactNode
    {
        if (this.props.value.lenght == 0)
            return <b> - </b>;

        return <b>
            {
                this.props.value.map((itm: Term) =>
                {
                    return itm.termCode;
                }).join(", ")
            }
        </b>;
    }
}

export default TermRendererLine;